import React from 'react';
import { useMapContext } from '@hero/web-context';
import { PickupMarker, DropoffMarker, DefaultLocationMarker } from './index';

/**
 * LocationMarkers - Renders all location markers (default or custom)
 * Uses context to access marker configurations and handlers
 */
export function LocationMarkers() {
  const ctx = useMapContext();

  // Hide markers when editing
  if (ctx.editingIndex !== null) {
    return null;
  }

  return (
    <>
      {ctx.markers.map((marker, index) => {
        const isOrigin = index === 0;

        if (ctx.markerIcon === 'order_pickup_dropoff_icons') {
          return (
            <React.Fragment key={`custom-marker-${index}`}>
              {isOrigin ? (
                <PickupMarker
                  location={marker.location}
                  onClick={() => ctx.handleCardClick(index)}
                  isEditing={ctx.editingIndex === index}
                />
              ) : (
                <DropoffMarker
                  location={marker.location}
                  index={index}
                  onClick={() => ctx.handleCardClick(index)}
                  isEditing={ctx.editingIndex === index}
                />
              )}
            </React.Fragment>
          );
        }

        // Use DefaultLocationMarker for normal_location_icon mode
        return (
          <DefaultLocationMarker
            key={`default-marker-${index}`}
            location={marker.location}
            index={index}
            onClick={() => ctx.handleCardClick(index)}
            draggable={marker.draggable}
            onDragEnd={(e: google.maps.MapMouseEvent) => {
              if (e.latLng && marker.onDragEnd) {
                marker.onDragEnd({ lat: e.latLng.lat(), lng: e.latLng.lng() });
              }
            }}
          />
        );
      })}
    </>
  );
}
